import { isNotEmpty, useForm } from "@mantine/form";
import { Paper, Stack, TextInput, Button, Flex } from "@mantine/core";
import { validateEmail, validatePhone } from "../../validation/validation";
import PhoneField from "../../components/PhoneField";
import { useSetState } from "@mantine/hooks";

export type FormValues = {
    email: string;
    firstName: string;
    lastName: string;
    phone: string;
    country: string;
};

interface CustomerFormProps {
    onSubmit: (values: FormValues) => void;
}

const CustomerForm = (props: CustomerFormProps) => {
    const { onSubmit } = props;

    const [{ loading }, setState] = useSetState({
        loading: false,
    });

    const form = useForm({
        initialValues: {
            email: "",
            firstName: "",
            lastName: "",
            phone: "",
            country: "",
        },
        validateInputOnChange: true,
        validateInputOnBlur: true,
        validate: {
            email: (value) => validateEmail(value),
            firstName: isNotEmpty("First name is required"),
            lastName: isNotEmpty("Last name is required"),
            phone: (value) => validatePhone(value),
        },
    });

    const formOnSubmit = form.onSubmit(async (values) => {
        try {
            setState({ loading: true });

            await onSubmit(values);
        } catch (e) {
            console.log(e);
        } finally {
            setState({ loading: false });
        }
    });

    return (
        <Paper radius="md" p="md" withBorder pos="relative">
            <form noValidate onSubmit={formOnSubmit}>
                <Stack>
                    <TextInput
                        label="First Name"
                        placeholder="First Name"
                        required
                        radius="md"
                        {...form.getInputProps("firstName")}
                    />
                    <TextInput
                        label="Last Name"
                        placeholder="Last Name"
                        required
                        radius="md"
                        {...form.getInputProps("lastName")}
                    />
                    <TextInput
                        required
                        label="Email"
                        placeholder="hello@eql.ai"
                        {...form.getInputProps("email")}
                        radius="md"
                    />
                    <PhoneField
                        required
                        label="Phone"
                        {...form.getInputProps("phone")}
                        onChange={(phone: string, country: string) => {
                            form.setFieldError("phone", null);
                            form.setValues({ phone, country });
                            form.isTouched("phone") &&
                                form.setFieldError(
                                    "phone",
                                    validatePhone(phone)
                                );
                        }}
                        radius="md"
                    />
                </Stack>
                <Flex justify="flex-end" mt="md">
                    <Button
                        type="submit"
                        disabled={!form.isValid()}
                        loading={loading}
                    >
                        Submit
                    </Button>
                </Flex>
            </form>
        </Paper>
    );
};

export default CustomerForm;
